import React from 'react'

import WarningBase from './base'
import illustrationIrrf from 'static/irrf-auto-retencao.png'

const IrrfAutoRetencao = () => (
  <WarningBase
    content={<div>Irrf Auto Retenção.</div>}
    image={<img src={illustrationIrrf} className="WarningImage-irrf" alt="irrf" />}
  />
)

export default IrrfAutoRetencao



// WEBPACK FOOTER //
// ./src/app/pages/DashboardResume/Warning/irrf-auto-retencao.js